import { useEffect, useRef } from "react";
import { generateGridLines, GridSettings } from "../../../helpers/snapToGrid";

interface MapGridProps {
    map: google.maps.Map | undefined;
    gridSettings: GridSettings;
    referencePoint?: google.maps.LatLng;
}

export const MapGrid: React.FC<MapGridProps> = ({ map, gridSettings, referencePoint }) => {
    const polylinesRef = useRef<google.maps.Polyline[]>([]);
    const listenersRef = useRef<google.maps.MapsEventListener[]>([]);

    useEffect(() => {
        const cleanup = () => {
            polylinesRef.current.forEach((p) => p.setMap(null));
            polylinesRef.current = [];

            listenersRef.current.forEach((listener) => listener.remove());
            listenersRef.current = [];
        };

        if (!map || !gridSettings.enabled) {
            cleanup();
            return;
        }

        const updateGrid = () => {
            const bounds = map.getBounds();
            if (!bounds) return;

            polylinesRef.current.forEach((p) => p.setMap(null));
            polylinesRef.current = [];

            const lines = generateGridLines(bounds, gridSettings, referencePoint);

            const newPolylines = lines.map((line) => {
                return new google.maps.Polyline({
                    path: line.path,
                    strokeColor: "#2196F3",
                    strokeOpacity: 0.3,
                    strokeWeight: 1,
                    map: map,
                    clickable: false,
                    zIndex: 1,
                });
            });

            polylinesRef.current = newPolylines;
        };

        updateGrid();

        const boundsListener = map.addListener("bounds_changed", updateGrid);
        const zoomListener = map.addListener("zoom_changed", updateGrid);

        listenersRef.current = [boundsListener, zoomListener];

        return cleanup;
    }, [map, gridSettings.enabled, gridSettings.sizeMeters, referencePoint]);

    return null;
};
